export default __webpack_public_path__ + "static/media/08.f8755d06.jpeg";